import { CityInformation } from './classes/city-information';
import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {

  invokeFirstComponentFunction = new EventEmitter();
  
  invokeWeatherChangedFunction = new EventEmitter();



  subsVar: Subscription;

  constructor() { }

  onFirstComponentButtonClick(name: number) {
    this.invokeFirstComponentFunction.emit(name);
  }

  onWeatherChanged(weather: string, city: string) {
    this.invokeWeatherChangedFunction.emit({weather, city});
  }


}
